import Cookies from 'js-cookie';
import getDomainName from '@/services/functions/get-domain-name';

export default function tokenStoreFactory() {
  function saveToken(token) {
    Cookies.set('AUTH_TOKEN', token, {
      path: '/',
      secure: false,
      expires: 7,
      sameSite: 'Lax',
      ...(
        process.env.NODE_ENV === 'production'
          ? {
            Domain: `.${getDomainName(window.location.hostname)}`,
          }
          : {}
      ),
    });
  }

  function getSavedToken() {
    return Cookies.get('AUTH_TOKEN');
  }

  function clearToken() {
    return Cookies.remove('AUTH_TOKEN', {
      path: '/',
      secure: false,
      expires: 7,
      sameSite: 'Lax',
      ...(
        process.env.NODE_ENV === 'production'
          ? {
            Domain: `.${getDomainName(window.location.hostname)}`,
          }
          : {}
      ),
    });
  }

  return {
    saveToken,
    getSavedToken,
    clearToken,
  };
}
